export default __webpack_public_path__ + "static/media/impacted.b5d631c1.webp";